import { css, Theme } from "@emotion/react";
import { theme } from "styles/theme";

export const InputPhoneNumberStyle = {
  self: ({ colors }: Theme) => css`
    &.PhoneInputInput,
    .PhoneInputInput {
      font-size: 14px;
      color: #000000;
      font-weight: 500;
      padding-top: 4px;
    }
  `,

  inputContainer: () => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    /* padding-right: 12px; */
    background: ${theme.colors.black100};
    color: ${theme.colors.lightText};
    border: 1px solid ${theme.borders.secondary};
    border-radius: 8px;
    overflow: hidden;
  `,
  inputPhoneNumber: () => css`
    flex: 1;
    width: 100%;
    height: 44px;
    padding-left: 12px;

    .PhoneInput {
      width: 100%;
    }

    .PhoneInputCountrySelect option[value="ZZ"] {
      display: none !important;
    }
    .PhoneInputInput {
      min-width: 0;
      width: 100%;
      height: 44px;
      border: 0px;
      outline: none;
      padding-left: 16px;
      background: ${theme.colors.black100};
      color: ${theme.colors.lightText};

      &::placeholder {
        opacity: 0.6;
        color: ${theme.colors.lightText};
      }
    }

    .PhoneInputInput:disabled {
      background: #363636;
      opacity: 1;
    }

    .PhoneInputCountrySelectArrow {
      margin-left: 8px !important;
    }
  `,
};
